import global from "@/locales/cs-CZ/global";
import error403 from "@/locales/cs-CZ/errors/403";
import error404 from "@/locales/cs-CZ/errors/404";
import error500 from "@/locales/cs-CZ/errors/500";
import error503 from "@/locales/cs-CZ/errors/503";
import error504 from "@/locales/cs-CZ/errors/504";
import maintenance from "@/locales/cs-CZ/auth/maintenance";
import toast from "@/locales/cs-CZ/toast/toast";
import login from "@/locales/cs-CZ/auth/login";
import onboarding from "@/locales/cs-CZ/auth/onboarding";
import loginPageSteps from "@/locales/cs-CZ/loginPageSteps";
import dashboard from "@/locales/cs-CZ/dashboard/dashboard";
import account from "@/locales/cs-CZ/account/account";
import mailbox from "@/locales/cs-CZ/account/mailbox";
import bankstatement from "@/locales/cs-CZ/account/bankstatement";
import myApps from "@/locales/cs-CZ/my-apps/myApps";
import about from "@/locales/cs-CZ/about/about";
import contactService from "@/locales/cs-CZ/about/contactService";
import salesPromotions from "@/locales/cs-CZ/sales/promotions";
import brochures from "@/locales/cs-CZ/sales/brochures";
import shop from "@/locales/cs-CZ/shop/data";
import priceList from "@/locales/cs-CZ/shop/priceList";
import staff from "@/locales/cs-CZ/dashboard/staff";
import promotions from "@/locales/cs-CZ/promotions";
import points from "@/locales/cs-CZ/points";
import trainings from "@/locales/cs-CZ/trainings/trainings";
import vouchers from "@/locales/cs-CZ/vouchers/vouchers";
import media from "@/locales/cs-CZ/media/index";
import product from "@/locales/cs-CZ/product/index";
import message from "@/locales/cs-CZ/message/index";
import commitmentLetter from "@/locales/cs-CZ/account/commitmentLetter";
import multiplicator from "@/locales/cs-CZ/multiplicator";
import widgets from "@/locales/cs-CZ/widgets/widgets";
import consents from "@/locales/cs-CZ/consents/consents";
import investment from "@/locales/cs-CZ/investment/data";
import kickback from "@/locales/cs-CZ/kickback";
import portalHome from "@/locales/cs-CZ/portal-home/portalHome";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  widgets: widgets.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  portalHome: portalHome.messages,
  productBrochures: {
    BDriveTitle: "Obrázky produktů",
    BDriveLinkText: "Odkaz na portál OBRÁZKŮ PRODUKTŮ",
  },
}

export default {
  locale: "cs-CZ",
  messages,
};
